import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const projectDeailReducer = (state: RootState) => state.private.dettaglioProgetto;

export const costiSelector = createSelector(projectDeailReducer, (progetto) => progetto.costi);
export const ruoliSelector = createSelector(projectDeailReducer, (progetto) => progetto.ruoli);
export const allUsersSelector = createSelector(projectDeailReducer, (progetto) => progetto.allUsers);
export const teamDataSelector = createSelector(projectDeailReducer, (progetto) => progetto.teamData);
export const costsDataSelector = createSelector(projectDeailReducer, (progetto) => progetto.costsData);
export const revenuesToBeConsolidatedSelector = createSelector(
  projectDeailReducer,
  (progetto) => progetto.revenuesToBeConsolidated
);
export const competenzeAnnoSelector = createSelector(projectDeailReducer, (progetto) => progetto.competenzeAnno);
export const associatedContractsSelector = createSelector(
  projectDeailReducer,
  (progetto) => progetto.associatedContracts
);
export const revenueProgressSelector = createSelector(projectDeailReducer, (progetto) => progetto.revenueProgress);
export const feeRateTableSelector = createSelector(projectDeailReducer, (progetto) => progetto.feeRateTable);
export const emittedBillsSelector = createSelector(projectDeailReducer, (progetto) => progetto.emittedBills);
export const receivedBillsByCostSelector = createSelector(
  projectDeailReducer,
  (progetto) => progetto.receivedBillsByCost
);
